export default {
	tenantId: "dlvn_dev",
	appId: "covergo_crm",
	fileSystem: {
		bucketName: "dlvn--dev"
	}
}
